import { featureAtom } from "@sunrise/feature-flags";

export const backendRetryDelayInSecondsAtom = featureAtom<number | null>(
  "backend-retry-delay-in-seconds",
  5,
  {
    description: `The delay in seconds before retrying a failed backend request. If null, the request will be retried instantly.`,
  },
);
